export default __webpack_public_path__ + "static/media/p-completed.e7ec2055.svg";